export default __webpack_public_path__ + "static/media/logo.293af272.png";